/**
 * The bottom sheet's grab strip: handle, title, close (BON-534).
 *
 * Its own component because it is the only part of the sheet that does not
 * scroll, and therefore the only part the drag gesture may be bound to — the
 * distinction is worth being able to see in one place rather than inferring it
 * from where the props happen to be spread.
 */
import type { SheetDrag } from './useSheetDrag';

export interface ScopeSheetHeaderProps {
  /** What the sheet is picking. */
  title: string;
  onClose: () => void;
  drag: SheetDrag;
}

export function ScopeSheetHeader({ title, onClose, drag }: ScopeSheetHeaderProps) {
  return (
    <div {...drag.handleProps}>
      <div style={{ padding: '8px 0 0', display: 'flex', justifyContent: 'center' }}>
        <div
          aria-hidden="true"
          style={{ width: 38, height: 4, borderRadius: 999, background: 'var(--nb-border)' }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '6px 8px 8px 16px',
          borderBottom: '1px solid var(--nb-border)',
        }}
      >
        <h2 className="nb-display" style={{ margin: 0, fontSize: 14, letterSpacing: '.04em' }}>
          {title}
        </h2>
        <div style={{ flex: 1 }} />
        <button
          type="button"
          onClick={onClose}
          aria-label="Close"
          style={{
            width: 44,
            height: 44,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            border: 0,
            background: 'transparent',
            cursor: 'pointer',
            color: 'var(--nb-muted)',
          }}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            aria-hidden="true"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
}
